import axios from 'axios';
import { DataService } from '../dataService';

const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;
const headers = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'Access-Control-Allow-Origin': '*',
  crossDomain: true,
};

export const bookCategoryService = {
  getBookApi: (data, sortObject) => {
    let response;

    if (Object.keys(sortObject).includes('book_name')) {
      response = DataService.get(`/book/manage?search[${Object.keys(sortObject)[0]}]=${Object.values(sortObject)[0]}`);
    } else {
      response = DataService.get('/book/manage', data);
    }

    return response;
  },

  getAllBookApi: () => {
    return DataService.get(`/book/manage`);
  },
  getAllBookCloneApi: (data, sortObject) => {
    let response;
    if (sortObject && Object.keys(sortObject).includes('book_name')) {
      response = DataService.get(
        `/book/manage-clone?search[${Object.keys(sortObject)[0]}]=${Object.values(sortObject)[0]}`
      );
    } else {
      response = DataService.get('/book/manage-clone', data);
    }
    return response;
  },
  deleteBookCloneApi: (id) => {
    return DataService.delete(`/book/manage-clone/${id}`);
  },

  BooksAddApi: (data) => {
    return DataService.post('/book/manage', data, {
      'Content-Type': 'multipart/form-data',
    });
  },

  getBookDetailsApi: (id) => {
    return DataService.get(`/book/manage/${id}`);
  },
  updateBookApi: (id, data) => {
    return DataService.put(`/book/manage/${id}`, data, {
      'Content-Type': 'multipart/form-data',
    });
  },
  updateBookStatusApi: (id, status) => {
    return DataService.patch(`/book/manage/${id}`, status);
  },
  deleteBookApi: (_id) => {
    return DataService.delete(`/book/manage/${_id}`);
  },

  ///// static api book

  getStaticBookApi: (data) => {
    try {
      return axios.get(`${REACT_APP_API_BASEURL + 'static/book-category'}`, {
        headers: headers,
      });
    } catch (error) {
      console.log('error', error);
    }
    // DataService.get('/static/book-category', data);
  },
  getStaticBookListApi: (search) => {
    try {
      return axios.get(`${REACT_APP_API_BASEURL}static/books?search[book_name]=${search}`, {
        headers: headers,
      });
    } catch (error) {
      console.log('error', error);
    }
    // DataService.get(`/static/books?search[book_name]=${search}`);
  },

  getInstructorBookListApi: (search) => {
    // return DataService.get(`/static/clone-books?search[book_name]=${search}`);
    try {
      return axios.get(`${REACT_APP_API_BASEURL}static/clone-books?search[book_name]=${search}`, {
        headers: headers,
      });
    } catch (error) {
      console.log('error', error);
    }
  },

  getStaticBookDetailApi: (id) => {
    return DataService.get(`/static/book-slug/${id}`);
  },
  getChapterApi: (id) => {
    return DataService.get(`/static/chapter/${id}`);
  },
  getHeaderOneApi: (id) => {
    return DataService.get(`/static/main-book/header-1/${id}`);
  },
  getHeaderTwoApi: (id) => {
    return DataService.get(`/static/main-book/header-2/${id}`);
  },
  getHeaderThreeApi: (id) => {
    return DataService.get(`/static/main-book/header-3/${id}`);
  },

  getStaticPagination: (id) => {
    return DataService.get(`/static/chapters-headers-sequence-slug/${id}`);
  },

  getStaticBookContent: (bookslug) => {
    return DataService.get(`/content/${bookslug}`);
  },

  getStaticChapterContent: (bookslug, chapterslug) => {
    return DataService.get(`/content/${bookslug}/${chapterslug}`);
  },
  getStaticHeaderOneContent: (bookslug, chapterslug, headerone) => {
    return DataService.get(`/content/${bookslug}/${chapterslug}/${headerone}`);
  },
  getStaticHeaderTwoContent: (bookslug, chapterslug, headerone, headertwo) => {
    return DataService.get(`/content/${bookslug}/${chapterslug}/${headerone}/${headertwo}`);
  },
  getStaticHeaderThreeContent: (bookslug, chapterslug, headerone, headertwo, headerthree) => {
    return DataService.get(`/content/${bookslug}/${chapterslug}/${headerone}/${headertwo}/${headerthree}`);
  },

  // Join Class by Referral code
  cloneBookCostByReferral: (data) => {
    return DataService.get(`/student/referral-code/clone-book-cost`, data);
  },

  joinClassByReferral: (data) => {
    return DataService.post(`/student/referral-code/join-class`, data);
  },

  getBookByCategory: (category) => {
    return DataService.get(`/book/category-books/${category}`);
  },
  updatePositions: (data) => {
    return DataService.post('/book/update-positions', data);
  },
};
